"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=elastic.log.js.map